import { CERTIFICATES } from "../data/certificates";

function Certificates() {
  return (
    <section className="section" id="certificates">
      <div className="wrap">
        <div className="section-head reveal">
          <h2 className="section-title">
            Verified <em>certificates</em>
          </h2>
          <p className="section-note">
            Coursera courses and guided projects — each certificate links to its
            live verification page.
          </p>
        </div>

        <div className="cert-grid">
          {CERTIFICATES.map((c, i) => (
            <article className="cert-card reveal" data-d={i + 1} key={c.key}>
              <a
                className="cert-preview"
                href={c.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`Verify ${c.title} certificate on Coursera`}
              >
                <img src={c.image} alt={`${c.title} — certificate`} loading="lazy" />
              </a>
              <div className="cert-body">
                <h4>{c.title}</h4>
                <span className="cert-meta">
                  {c.issuer} · {c.date}
                </span>
                <div className="cert-links">
                  <a href={c.href} target="_blank" rel="noreferrer">
                    Verify →
                  </a>
                  <a href={c.pdf} target="_blank" rel="noreferrer">
                    PDF
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Certificates;
